import { render, staticRenderFns } from "./LayoutB.vue?vue&type=template&id=6a266e62&scoped=true"
import script from "./LayoutB.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutB.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LayoutB.vue?vue&type=style&index=0&id=6a266e62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a266e62",
  null
  
)

export default component.exports